import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthShell } from "@/components/AuthShell";
import { Field } from "@/pages/auth/Login";
import { useAuth, fmtErr } from "@/context/AuthContext";
import { Seo } from "@/components/Seo";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    const ref = new URLSearchParams(window.location.search).get("ref");
    try {
      await register({ name, email, password, ref });
      nav("/onboarding");
    } catch (e2) {
      setErr(fmtErr(e2.response?.data?.detail) || e2.message);
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Create your free account" subtitle="Start analyzing markets with KREONIS."
      footer={<>Already have an account? <Link to="/login" className="font-semibold text-primary">Log in</Link></>}>
      <Seo title="Start Free" />
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        <Field label="Name" value={name} onChange={setName} testid="register-name" placeholder="Alex Trader" />
        <Field label="Email" type="email" value={email} onChange={setEmail} testid="register-email" />
        <Field label="Password" type="password" value={password} onChange={setPassword} testid="register-password" placeholder="At least 6 characters" />
        {err && <p className="text-sm text-bearish" data-testid="register-error">{err}</p>}
        <button disabled={loading} data-testid="register-submit" className="w-full rounded-xl bg-primary py-2.5 text-sm font-semibold text-primary-foreground disabled:opacity-60">
          {loading ? "Creating account…" : "Start Free"}
        </button>
        <p className="text-center text-xs text-muted-foreground">By continuing you agree to our <Link to="/terms" className="underline">Terms</Link> and <Link to="/risk-disclosure" className="underline">Risk Disclosure</Link>.</p>
      </form>
    </AuthShell>
  );
}
